import React from 'react';
import { AiFillGithub } from 'react-icons/ai';
import { BiLinkExternal } from 'react-icons/bi';

function Projects({image, name, live, source, desc}) {
  return (
    <div className='group flex flex-col bg-white dark:bg-[#2a3038] rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 h-full'>
        {/* Project Image with Hover Description Overlay */}
        <div className='relative overflow-hidden h-48 sm:h-56 md:h-64 bg-gray-200 dark:bg-gray-700'>
            <img 
              alt='project' 
              src={image} 
              className='w-full h-full object-cover transition-transform duration-500 group-hover:scale-110' 
            />
            
            {/* Hover Overlay with Description */}
            <div className='absolute inset-0 bg-gradient-to-br from-[#ec6e59]/95 to-[#d95d4a]/95 opacity-0 group-hover:opacity-100 transition-all duration-300 flex items-center justify-center p-4 sm:p-6'>
              <div className='text-white text-center transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300'>
                <p className='text-sm sm:text-base leading-relaxed line-clamp-6 sm:line-clamp-none'>
                  {desc}
                </p>
              </div>
            </div>
        </div>
        
        {/* Project Content */}
        <div className='flex flex-col flex-grow p-5 sm:p-6'>
            <h1 className='text-lg sm:text-xl font-bold text-[#ec6e59] mb-4 sm:mb-6'>{name}</h1>
            
            {/* Action Buttons */}
            <div className='flex gap-3 sm:gap-4 mt-auto'>
                {live && (
                  <a 
                    href={live} 
                    target='_blank' 
                    rel='noreferrer' 
                    className='flex-1 flex items-center justify-center gap-2 bg-[#ec6e59] hover:bg-[#d95d4a] text-white px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-300 hover:scale-105'
                  >
                    <BiLinkExternal className='w-4 h-4' />
                    Demo
                  </a>
                )}
                <a 
                  href={source} 
                  target='_blank' 
                  rel='noreferrer' 
                  className={`${live ? 'flex-1' : 'w-full'} flex items-center justify-center gap-2 px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 hover:border-[#ec6e59] dark:hover:border-[#ec6e59] rounded-lg text-sm font-medium bg-white dark:bg-[#20262E] hover:bg-gray-50 dark:hover:bg-[#2a3038] transition-all duration-300`}
                >
                  <AiFillGithub className='w-5 h-5' /> Code
                </a>
            </div>
        </div>
    </div>
  );
}

export default Projects;
